// extracted by mini-css-extract-plugin
module.exports = {"guidelines":"Guideline_guidelines__ZXjox","guidelines--invalid":"Guideline_guidelines--invalid___QJ21"};